import React, { useState } from 'react';
import { Button, Box } from '@mui/material';
import ConfirmationDialog from './ConfirmationDialog'; // Make sure to import your ConfirmationDialog component

const QuizButtons = ({ 
    isVerySmallScreen, 
    isMobile, 
    currentQuestionIndex, 
    handlePrevious, 
    handleNextQuestion, 
    handleConfirmExit, 
    lngsltd, 
    questions 
}) => {
    // State to control the confirmation dialog visibility
    const [openConfirmation, setOpenConfirmation] = useState(false);

    // Open the confirmation dialog when the exit button is clicked
    const handleExitClick = () => {
        setOpenConfirmation(true);
    };

    // Close the confirmation dialog without exiting
    const handleConfirmClose = () => {
        setOpenConfirmation(false);
    };

    // Confirm and handle exit logic
    const handleConfirm = () => {
        setOpenConfirmation(false);
        handleConfirmExit(); // Call the exit function passed as a prop
    };

    return (
        <>
            <Box 
                display="flex" 
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    width: '100%',
                    flexDirection: isVerySmallScreen ? 'column' : 'row',
                    gap: isVerySmallScreen ? 2 : 0
                }}
            >
                <Button
                    variant="outlined"
                    onClick={handleExitClick}
                    sx={{
                        fontSize: isMobile ? '0.875rem' : '1rem',
                        fontWeight: 500,
                        px: 3,
                        py: 1.25,
                        borderRadius: '8px',
                        borderColor: '#dc3545',
                        color: '#dc3545',
                        textTransform: 'none',
                        width: isVerySmallScreen ? '100%' : 'auto',
                        minWidth: '120px',
                        '&:hover': {
                            borderColor: '#b02a37',
                            backgroundColor: 'rgba(220, 53, 69, 0.05)',
                            transform: 'translateY(-1px)',
                            boxShadow: '0 4px 8px rgba(220, 53, 69, 0.2)'
                        },
                        transition: 'all 0.2s ease-in-out'
                    }}
                >
                    {lngsltd["Exit"]}
                </Button>

                <Box
                    display="flex"
                    flexDirection={isVerySmallScreen ? 'column' : 'row'}
                    gap={2}
                    width={isVerySmallScreen ? '100%' : 'auto'}
                    ml={isMobile && !isVerySmallScreen ? 2 : 0} // Add left margin on mobile (but not on very small screens where it's column)
                >
                    {currentQuestionIndex > 0 && (
                        <Button
                            variant="outlined"
                            onClick={handlePrevious}
                            sx={{
                                fontSize: isMobile ? '0.875rem' : '1rem',
                                fontWeight: 500,
                                px: 3,
                                py: 1.25,
                                borderRadius: '8px',
                                borderColor: '#6c757d',
                                color: '#6c757d',
                                textTransform: 'none',
                                width: isVerySmallScreen ? '100%' : 'auto',
                                minWidth: '120px',
                                '&:hover': {
                                    borderColor: '#5a6268',
                                    backgroundColor: 'rgba(108, 117, 125, 0.05)',
                                    transform: 'translateY(-1px)',
                                    boxShadow: '0 4px 8px rgba(108, 117, 125, 0.2)'
                                },
                                transition: 'all 0.2s ease-in-out'
                            }}
                        >
                            {lngsltd["Previous"]}
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        onClick={handleNextQuestion}
                        sx={{
                            fontSize: isMobile ? '0.875rem' : '1rem',
                            fontWeight: 600,
                            px: 4,
                            py: 1.25,
                            borderRadius: '8px',
                            backgroundColor: '#dc3545',
                            textTransform: 'none',
                            width: isVerySmallScreen ? '100%' : 'auto',
                            minWidth: '140px',
                            '&:hover': {
                                backgroundColor: '#b02a37',
                                transform: 'translateY(-1px)',
                                boxShadow: '0 4px 12px rgba(220, 53, 69, 0.3)'
                            },
                            transition: 'all 0.2s ease-in-out'
                        }}
                    >
                        {currentQuestionIndex === questions.length - 1 ? lngsltd["Finish"] : lngsltd["Next"]}
                    </Button>
                </Box>
            </Box>

            {/* Confirmation Dialog */}
            <ConfirmationDialog
                open={openConfirmation}
                onClose={handleConfirmClose}
                onConfirm={handleConfirm}
                lngsltd={lngsltd}
                title={lngsltd["Confirmation"]}
                message={lngsltd["Are you sure you want to exit the quiz?"]}
            />
        </>
    );
};

export default QuizButtons;
